import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { Button } from "../Button";
import { ButtonTypes, TextColors, TextTypes } from "../constants";
import { Text } from "../Text";

import "./styles.scss";

export const Popup = ({
  children,
  className,
  disabled,
  footer,
  primaryOnClick,
  primaryText,
  secondaryOnClick,
  secondaryText,
  subtitle,
  title,
  ...props
}) => (
  <div
    className={createClassNameString([className, "apti-Popup", disabled ? "disabled" : "enabled"])}
    {...props}
  >
    <div className={createClassNameString([className, "apti-Popup__container"])}>
      <div className="apti-Popup__content">
        <Text
          className={createClassNameString([className, "apti-Popup__title"])}
          type={TextTypes.heading1}
        >
          {title}
        </Text>
        <Text
          className={createClassNameString([className, "apti-Popup__subtitle"])}
          color={TextColors.grey}
          type={TextTypes.subtitle}
        >
          {subtitle}
        </Text>
        {children}
        <div className={createClassNameString([className, "apti-Popup__buttons"])}>
          <Button buttonType={ButtonTypes.primaryOutline} onClick={secondaryOnClick}>
            {secondaryText}
          </Button>
          <Button buttonType={ButtonTypes.primary} onClick={primaryOnClick}>
            {primaryText}
          </Button>
        </div>
        <p className={createClassNameString([className, "apti-Popup__footer"])}>{footer}</p>
      </div>
    </div>
  </div>
);

Popup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  primaryOnClick: PropTypes.func.isRequired,
  secondaryOnClick: PropTypes.func.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

Popup.defaultProps = {
  children: <></>,
  className: undefined,
  disabled: false,
  footer: "",
  primaryOnClick: () => {},
  primaryText: "Confirm",
  secondaryOnClick: () => {},
  secondaryText: "Cancel",
  subtitle: "",
  title: "",
};
